import React from 'react'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

// Custom Style
import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, blackColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import lockScreenLoadingStyle from '../../styles/jss/components/lockScreenLoading/lockScreenLoadingStyle'


// Custom Style (Typography)
const LoadingTypography = withStyles({
	root: {
		"fontSize": 20,
		"fontWeight": 600,
		"color": whiteColor,
	},
}) (Typography)

const WaitTypography = withStyles({
	root: {
		"fontSize": 15,
		"fontWeight": 400,
		"color": whiteColor,
	},
}) (Typography)


const useStyles = makeStyles(theme => lockScreenLoadingStyle(theme))

const LockScreenLoading = props => {
	const {open, circleSize, progressTitle} = props
	const classes = useStyles()

	return (
		<div>
			<Backdrop className={classes.backdrop} open={open}>
				<Box position="relative" display="inline-flex">
					<CircularProgress size={circleSize + "px"} className={classes.circular} />
					<Box
						top={0}
						left={0}
						bottom={20}
						right={0}
						position="absolute"
						display="flex"
						alignItems="center"
						justifyContent="center"
					>
						<LoadingTypography>{progressTitle}</LoadingTypography>
					</Box>

					<Box
						top={30}
						left={0}
						bottom={0}
						right={0}
						position="absolute"
						display="flex"
						alignItems="center"
						justifyContent="center"
					>
						{/* <Typography variant="caption" component="div" color="textSecondary">Please Wait</Typography> */}
						<WaitTypography>Please Wait</WaitTypography>
					</Box>
				</Box>
			</Backdrop>
		</div>
	)
}

export default LockScreenLoading
